"use client";

import { c as _c } from "react/compiler-runtime";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { twMerge } from "tailwind-merge";
import { useFilterContext } from "./filter-context";
export default function SearchFilter() {
  const $ = _c(7);
  const {
    search,
    updateSearch
  } = useFilterContext();
  let t0;
  if ($[0] !== updateSearch) {
    t0 = function handleChange(event) {
      updateSearch(event.target.value);
    };
    $[0] = updateSearch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleChange = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MagnifyingGlassIcon className="absolute bottom-0 left-3 top-0 my-auto h-5 w-5" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = twMerge("border-gray-300 text-gray-900", "ring-teal-700 dark:text-white dark:placeholder-gray-400", "w-full border-b-2 bg-transparent p-3 pl-10 text-lg outline-hidden ring-inset focus:ring-2");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleChange || $[5] !== search) {
    t3 = <div className="relative">{t1}<input type="search" className={t2} onChange={handleChange} placeholder={"S\xF6k"} value={search} /></div>;
    $[4] = handleChange;
    $[5] = search;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}